import CountUp from "react-countup";
import { Col, Row } from "reactstrap";
import { SocialData } from "../../../../../Data/Applications/Users/Users";

const FollowSection = () => {
  return (
    <div className="follow">
      <Row>
        {SocialData.map((item, index) => (
          <Col xs="6" className={item.class} key={index}>
            <div><CountUp end={item.count} className="follow-num counter" delay={1} /></div>
            <span>{item.text}</span>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default FollowSection;
